/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useSDMCustomerContext } from '@ldp/sdm-contexts';
import { useEffect, type FC } from 'react';

import { SdmProvince } from '@/data/constants';
import { isPharmaprixBanner, setSelectedProvinceCookie } from '@/utils';
import { IMasthead } from './masthead.interface';
import MastheadComponentSSR from '@/packages/ldp-core-sdm/src/components/masthead/masthead-ssr.component';

let provinceSelectorLock = false;

const MastheadSSR: FC<IMasthead & { enableSSR?: boolean }> = ({ headerSection, ...rest }) => {
  const { region } = headerSection as any;
  const { provinceId, setProvinceId } = useSDMCustomerContext();

  useEffect(() => {
    if (!isPharmaprixBanner() && region && Object.values(SdmProvince).includes(region as SdmProvince)) {
      setProvinceId(region);
    }
  }, []);

  useEffect(() => {
    // this only happens during page initialization, so we make sure to ignore the province value jumping back & forth
    provinceSelectorLock = true;
    setTimeout(() => {
      provinceSelectorLock = false;
    }, 500);
  }, []);

  useEffect(() => {
    setSelectedProvinceCookie(provinceId);
    if (!isPharmaprixBanner() && !provinceSelectorLock) {
      window.location.href = window.location.href.replace(/province=[A-Z]{2}&?/, '').replace(/[&?]$/, '');
    }
  }, [provinceId]);

  if (!headerSection) {
    return null;
  }

  return <MastheadComponentSSR headerData={headerSection} />;
};

export default MastheadSSR;
